import MainLayout from "@/components/layout/MainLayout.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";
import { required, maxLength, between, requiredIf } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import { fetchNotificationCount } from "@/services/common/notification-service";

export default {
    name: "editCourse",

    components: {
        MainLayout
    },

    data() {
        return {
            updateCourseForm: {
                category_id: "",
                course_title: "",
                course_explanation: "",
                course_details: "",
                certificate: "",
                course_type: "",
                fee: "",
                access_type: "",
                access_expiry_duration: null,
                course_photo: "",
                oldImg: "",
            },
            courses: [],
            category: [],
            submitted: false,
            disabled: 0,
            editor: ClassicEditor,
            oldCourseType: 0,
            editorConfig: {
                toolbar: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "bulletedList",
                    "numberedList"
                ]
            },
            video: false,
            type: 0,
            course_photo: '',
        };
    },

    validations: {
        updateCourseForm: {
            category_id: {
                required
            },
            course_title: {
                required,
                maxLength: maxLength(100)
            },
            course_explanation: {
                required,
                maxLength: maxLength(1000)
            },
            course_details: {
                required,
                maxLength: maxLength(5000)
            },
            certificate: {
                required
            },
            course_type: {
                required
            },
            access_type: {
                required: requiredIf(function () {
                    return this.updateCourseForm.course_type == 3; // Validate access_type only for video courses
                }),
            },
            access_expiry_duration: {
                required:requiredIf( function () {
                    return (
                        this.updateCourseForm.course_type == 3 &&
                        this.updateCourseForm.access_type == 2
                    );
                }),
                between: between(1, 120),
            }
        }
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        onChange(event) {
            var optionValue = event.target.value;
            var optionText = event.target.options[event.target.options.selectedIndex].text;
            this.updateCourseForm.category_id = optionValue;
            this.updateCourseForm.category_name = optionText;
        },

        onCourseTypeChange(event) {
            this.type = event.target.value;
            if (event.target.value == 3) {
                this.video = true;
            } else {
                this.video = false;
            }
        },

        chooseFiles(id) {
            document.getElementById(id).click();
        },

        onCoursePhotoChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return null;
            this.updateCourseForm.course_photo = e.target.files[0];
            let reader = new FileReader();
            reader.onload = (e) => {
                this.course_photo = e.target.result;
            };
            reader.readAsDataURL(files[0]);
        },

        removeImg(img) {
            this.$set(this, img, '');
            document.getElementById(img).value = '';
        },

        submit() {
            this.submitted = true;
            
            // Mark all fields as touched to trigger validation messages
            this.$v.updateCourseForm.$touch();
        
            // If any field is invalid, show the error notification and don't proceed
            if (this.$v.updateCourseForm.$invalid) {
                this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                    timer: 3,
                    position: "bottomCenter",
                });
                return;
            }
        
            // Proceed with the form submission
            this.updateCourse();
        },
        
        updateCourse() {
            this.updateCourseForm.course_photo = this.course_photo;
            if (this.updateCourseForm.course_type != this.oldCourseType) {
              this.$notification.error("အတန်းအမျိုးအစားပြောင်းလဲ၍မရပါ။", {
                timer: 3,
                position: "bottomCenter"
              });
              return;
            }
            var request = {
                category_id: this.updateCourseForm.category_id,
                course_title: this.updateCourseForm.course_title,
                course_explanation: this.updateCourseForm.course_explanation,
                course_details: this.updateCourseForm.course_details,
                certificate: this.updateCourseForm.certificate,
                course_type: this.updateCourseForm.course_type,
                fee: this.updateCourseForm.fee,
                course_photo: this.updateCourseForm.course_photo,
                oldImg: this.updateCourseForm.oldImg,
                access_type: this.updateCourseForm.access_type,
                access_expiry_duration: this.updateCourseForm.access_expiry_duration,
            };
            axios.post("my/course/" + this.$route.params.id + "/update", request)
                .then(() => {
                    this.$router.push({
                        name: "manageCourse"
                    });
                    this.$notification.success("လုပ်ဆောင်မှု အောင်မြင်ပါသည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course Filter API Error", error);
                });
        },

        getCourseDetail() {
            axios.get("my/course/" + this.$route.params.id)
                .then((response) => {
                    this.updateCourseForm = response.data;
                    this.disabled = response.data.approve_std !== 0;
                    this.course_photo = this.updateCourseForm.course_photo ? this.updateCourseForm.course_photo : null;
                    this.oldCourseType = this.updateCourseForm.course_type;
                    this.updateCourseForm.oldImg = this.updateCourseForm.old_photo;
                    this.updateCourseForm.access_type = response.data.access_type || "1";
                    this.updateCourseForm.access_expiry_duration = response.data.access_expiry_duration || null;
                            if (this.updateCourseForm.course_type == 3) {
                                this.video = true;
                    }
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    console.log("Course Detail API Error", error);
                });
        },

        getCategoryForCourse() {
            axios.get("course/categories")
                .then((response) => {
                    this.category = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error);
                });
        },
    },

    mounted() {
        this.getCategoryForCourse();
        this.getCourseDetail();
        fetchNotificationCount();
    }
};
